<section class="table-row">
  <div class="order-title row-item">
    {{order?.date_created| date:'MMM d, h:mm a'}}
  </div>
  <div class="order-title row-item long-text">
    <a class="db-link" [routerLink]="'../customers/customer-view/'+order?.customer?.customer_id">{{order?.customer?.email}}</a>
  </div>
  <div class="order-price row-item">
    {{order?.total && order?.currency_symbol}}{{order?.total}}
  </div>
  <div class="order-transaction-id row-item">
  </div>
  <div class="order-status row-item">
    <span class="mr8 {{order.status}}" [ngClass]="{'partially': order?.status === 'completed' && !!order?.refunds?.length && !fullRefunded }"></span>
    <p>{{order?.status === 'completed' && !!order?.refunds?.length && !fullRefunded ? ('text_partiallyRefunded' | dbText) : ('text_' + toCamelCase(order?.payment_status) | dbText)}}</p>
  </div>
  <div class="order-status-container row-item">
    <ds-dropdown
      [dsDropdownOptions]="statusOptions"
      [dsDropdownWidth]="'120px'"
      [value]="order?.status"
      [changeAfterConfirmation]="true"
      (onOptionChoose)="statusChange($any($event), order.id, order?.status === 'completed' && !!order?.refunds?.length && !fullRefunded )"></ds-dropdown>
  </div>
</section>
